import React, { useState } from "react";
import Quote from "./Quote"; // ✅ uses your full working quote page

export default function FluffySideClubQuote() {
  const [access, setAccess] = useState(false);
  const [input, setInput] = useState("");
  const PASSWORD = "fluffy123";

  return (
    <div className="min-h-screen bg-white">
      {!access ? (
        <div className="h-screen flex flex-col justify-center items-center bg-gray-100">
          <h1 className="text-lg mb-2 font-semibold">Private Quote Access</h1>
          <input
            type="password"
            placeholder="Enter password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="border px-4 py-2 rounded mb-3 w-64 text-center"
          />
          <button
            onClick={() => setAccess(input === PASSWORD)}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            View Quote
          </button>
        </div>
      ) : (
        <Quote /> // ✅ Renders full existing quote
      )}
    </div>
  );
}
